export const veeHelper = {

	methods: {


		//Helper functions
		validClasses(path) {

			return [
				this.errors.has(path) ? 'is-invalid' : '',
				this.isValid(path) ? 'is-valid' : ''
			];
		},
		validato(path, isValid){
			let p = path.split('.');
			let scope = null;
			let name = p[0];

			if (p.length > 1) {
				scope = p[0];
				name = p[1];
			}

			let flags;

			if (scope) {
				if (!this.fields['$' + scope]) {
					return false;
				}
				flags = this.fields['$' + scope][name];
			} else {
				flags = this.fields[name];

			}


			if (!flags) {
				//Wrong validation
				return false;
			} else if(isValid){
				//Check if field is VALID
				return flags.valid && flags.touched;
			}else{
				//Check if field is INVALID
				return flags.invalid || this.errors.has(path);

			}
		},
		isValid(path) {
			return this.validato(path, true)


		},
		isInValid(path) {
			return this.validato(path, false)
		},


		handleSipleValidation(validate) {
			//Check if we have any server validation errors
			if (validate && !_.isEmpty(validate)) {


				//Iterate through response validation object
				for (let prop in validate) {
					let path = prop;

					//Iterate through scope fields
					for (let scope in this.fields) {

						//Search for failed field in scope
						for (let field in this.fields[scope]) {
							if (field === prop) {
								let s = scope.replace('\$', '');
								path = s + '.' + prop; //Set path name for error


								//Stop iterate, because we found required field
								break;
							}
						}
						if (path !== prop) {
							break;
						}
					}

					let p = path.split('.');

					let error = {
						msg: this.t(validate[prop]),
						custom: true,
						id: path
					};

					if (p.length > 1) {
						error.scope = p[0];
						error.field = p[1];
					}else{
						error.field = path;
					}

					//Add error message to field
					this.errors.add(error);

				}
			}
		}
	}
};